import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labGuideItemEditRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/guide_items/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/lab/GuideItems/LabGuideItemEditPage/LabGuideItemEditPage').then((d) => d.Route)
);
